import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import UserProfile from 'containers/Profile';
import { SkeletonLoader } from 'containers/Search/Submissions';
import { useAuthContext } from 'context/AuthProvider';
import MetaTags from 'components/MetaTags';

const inValidValues = [undefined, null, 'undefined', 'null'];
import { logEvent } from 'utils/eventTracking';

const Profile = () => {
  const router = useRouter();
  const userData = useAuthContext();
  const queryParamsId = router?.query?.id?.toString();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (queryParamsId) {
      if (inValidValues.includes(queryParamsId)) {
        router.replace('/profile');
      }
      setIsLoading(false);
    }
    if (userData?.id !== router.query?.id?.toString())
      logEvent('PROFILE_PROFILE_VIEWED_BY_OTHER_USERS', {
        profile_user: router.query?.id?.toString() || ''
      });
  }, [router.query, userData?.id]);

  if (isLoading) return <SkeletonLoader />;

  const id = inValidValues.includes(queryParamsId)
    ? userData?.id
    : queryParamsId;

  if (id) {
    return (
      <>
        <MetaTags title="Profile" />
        <UserProfile loggedInUser={userData?.id} userId={id} />
      </>
    );
  }
  return null;
};

export default Profile;
